<template>
    <div class="header flex-group">
        <div class="icon icon-rever" v-if="type=='back'" @click="_goBack"><i class="iconfont qicon-jiantouyou"></i></div>
        <div class="icon" v-else @click="_goCenter"><i class="iconfont qicon-wodedamaijihuo"></i></div>
        <div class="title fz32" v-if="title">{{title}}</div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Header',
  props: ['type','title'],
  data(){
    return {

    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    _goBack(){
      this.$router.go(-1);
    },
    _goCenter(){
      this.$router.push('/Ucenter');
    }
  }
}
</script>
    
<style lang="scss" scoped>
    @function rem($px) {
      @return $px/100+rem;
    }
    .header{
      position: absolute;
      top: rem(50);
      left: rem(50);
      .title{
          margin-left: rem(20);
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue